import React, { useState, useEffect } from 'react';
// Import images
import galleryImg1 from '../img/envision/homeservices/updated/HEALTHCARE & LIFE SCIENCES - 04.jpg';
import galleryImg2 from '../img/envision/dropdown/new/automo.png';
import galleryImgs31 from '../img/envision/dropdown/new/cmd.jpg';
import galleryImg41 from '../img/envision/dropdown/new/cmd.jpg';

const galleryImages = [galleryImg1, galleryImg2];
const galleryImagess = [galleryImgs31, galleryImg41];

const HealthcareAboutdata = () => {
    const [currentImage, setCurrentImage] = useState(galleryImages[0]);
    const [currentImages, setCurrentImages] = useState(galleryImagess[0]);

    // Function to cycle through images in galleryImages (first gallery)
    const changeFirstImage = () => {
        setCurrentImage((prevImage) => {
            const currentIndex = galleryImages.indexOf(prevImage);
            return galleryImages[(currentIndex + 1) % galleryImages.length];
        });
    };

    // Function to cycle through images in galleryImagess (second gallery)
    const changeSecondImage = () => {
        setCurrentImages((prevImage) => {
            const currentIndex = galleryImagess.indexOf(prevImage);
            return galleryImagess[(currentIndex + 1) % galleryImagess.length];
        });
    };

    // useEffect for cycling through galleryImages (first image set)
    useEffect(() => {
        const intervalId = setInterval(changeFirstImage, 3000); // Change image every 3 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    // useEffect for cycling through galleryImagess (second image set)
    useEffect(() => {
        const intervalId = setInterval(changeSecondImage, 4000); // Change image every 4 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <section style={{ marginTop: '40px' }}>
            <div className="container">
                

                <div className="row">
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(236 115 34)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                           Healthcare &
                                <span style={{ color: '#000', marginLeft:'10px' }}>
                                   Lifesciences
                                </span>
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                At DREBCON, we empower the healthcare industry by addressing critical challenges in cybersecurity and achieving seamless global regulatory compliance thus enabling global expansion of your market. 
                                </p>
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                Our expertise drives manufacturing process optimization through the transformative power of Generative AI and Operational Technology (OT) modernization. By integrating intelligent IT transformation and robust governance frameworks, we deliver effective business value, 
                                </p>

                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                ensuring agility, innovation, and sustainability. With a focus on secure and compliant systems, we enable pharmaceutical organizations to thrive in an interconnected, data-driven, and highly regulated global marketplace.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img
                            src={galleryImg1} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '70%', marginTop:'40px' }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HealthcareAboutdata;
